import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
  Snackbar,
} from "@mui/material";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  AddCircle,
} from "@mui/icons-material";
import useFaqData from "../hooks/useFaqData";

const AddForm = ({ onAdd }) => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { postData, data } = useFaqData();

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      // Calculate next order automatically
      const nextOrder =
        data.length > 0
          ? Math.max(...data.map((faq) => faq.faq_order || 0)) + 1
          : 1;

      const newData = {
        title: title,
        faq_order: nextOrder,
        content: content,
      };
      await postData(newData);
      setSnackbarOpen(true);
      setTitle("");
      setContent("");
      onAdd(); // Trigger list refresh in parent component
    } catch (error) {
      console.error("Error adding FAQ:", error);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Card>
      <CardHeader
        title="Add FAQ"
        avatar={<AddCircleOutlineIcon />}
        sx={{ bgcolor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        <form onSubmit={handleFormSubmit}>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            required
            margin="normal"
          />
          <TextField
            label="Content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            fullWidth
            required
            margin="normal"
            multiline
            rows={4}
          />
          <Button
            type="submit"
            variant="outlined"
            color="success"
            endIcon={<AddCircle />}
          >
            Create FAQ
          </Button>
        </form>
      </CardContent>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="FAQ has been added"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
    </Card>
  );
};

export default AddForm;
